import { UserLoginData } from "../common/charts/Enums";
import "./platform-portal.css";

/**
 * Platform "My Settings" — profile only (Notification settings are intentionally omitted for the
 * Platform role). A Platform token carries no organizationUserId / MyProfile permission, so the
 * org-user `MyProfileComponent` (permission-gated + session-org-bound) can't be reused directly;
 * this is a lightweight read-only profile sourced from the login session.
 */
const MyProfilePlatform = () => {
  const fullName = sessionStorage.getItem(UserLoginData.user_name) || "—";

  return (
    <div className="platform-portal-page">
      <div className="top-listing-header-top">
        <h2 className="H2">My Profile</h2>
      </div>

      <div className="platform-info-card">
        <div className="platform-overview-grid">
          <div className="platform-overview-item">
            <label>Full Name</label>
            <p className="normal_text black m-0">{fullName}</p>
          </div>
          <div className="platform-overview-item">
            <label>Role</label>
            <p className="normal_text black m-0">Platform Administrator</p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default MyProfilePlatform;
